// Chart color palettes for different chart types
export const STANDARD_CHART_COLORS = [
  "#9a9a9a",  // SM Gray
  "#307bb9",  // SM Blue
  "#bb4040",  // Red
  "#008272",  // Teal
  "#4068b4",  // Darker Blue
  "#7ebce6",  // Light Blue
  "#8fba34",  // Light Green
  "#f64250",  // Bright Red
  "#fbbf22",  // Orange/Yellow
  "#94adbf",  // Light Gray/Blue
];

// Year-on-Year specific colors - customize these as needed
export const YOY_BAR_CHART_COLORS = [
  "#9a9a9a",  // SM Gray
  "#307bb9",  // SM Blue
  "#c026d3",  // Modern Fuchsia
  "#4f46e5",  // Modern Indigo
  "#059669",  // Modern Emerald
];

// You can also define other chart-specific colors
export const YOY_LINE_CHART_COLORS = [
  "#9a9a9a",  // SM Gray
  "#307bb9",  // SM Blue
  "#fbbf22",  // Orange/Yellow
  "#94adbf",  // Light Gray/Blue
];